 <template>
  <div class="page" v-cloak>

    <van-nav-bar title="购买结果" fixed left-arrow @click-left="goIndex"></van-nav-bar>
    <van-notice-bar v-if="isType != 1" class="top-tips" text="提示：积分现金混合支付，积分30分钟内返还到账户。" />

    <div class="top" v-if="isType == 1">
      <div class="icon">
        <van-icon name="checked" color="#ff5000" />
      </div>
      <div class="mt20 title">您已完成购买</div>
      <div class="mt10">如果有问题，请 <span class="contact" @click="makePhoneCall">联系我们</span></div>
    </div>

    <div class="top" v-else>
      <div class="icon">
        <van-icon name="clear" color="#C64545" />
      </div>
      <div class="mt20 title">付款失败，请重试</div>
      <div class="mt10">如果有问题，请 <span class="contact" @click="makePhoneCall">联系我们</span></div>
    </div>

    <div class="btn-block">
      <div class="btn" @click="goIndex">发现更多</div>
      <div class="btn btns" @click="goOrder">查看订单</div>
    </div>

    <!-- 猜你喜欢 -->
    <!-- <you-like-scroll :arrow="2"></you-like-scroll> -->

  </div>
</template>

<script>
// import youLikeScroll from "@/components/you-like-scroll/you-like-scroll.vue";
export default {
  name: 'PayResult',
  components: { 
    // youLikeScroll 
  },
  props: {},
  data() {
    return {
      isType: this.$route.query.isType || 1,
      aa: {}
    }
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        // console.log(newValue, oldValue)
      },
      deep: true // 深度监听表单
    },
  },
  created() { },
  mounted() { },
  methods: {
    // 返回订单
    goOrder() {
      this.$router.replace({
        name: 'order-list',
        query: {
          id: ''
        }
      });
    },
    // 跳首页
    goIndex() {
      this.$router.replace({
        name: 'index',
        query: {
          id: ''
        }
      });
    },
    makePhoneCall() {
       this.MakeCall() //拨打电话
    },
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  padding-top: 150px;

  .top {
    text-align: center;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #999999;
  }

  .icon {
    width: 85px;
    height: 85px;
    /* background: papayawhip; */
    font-size: 85px;
    margin: 0 auto;
  }

  .title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 30px;
    color: #2a2e43;
    letter-spacing: 2.5px;
  }

  .contact {
    color: #3497fd;
  }

  .btn-block {
    /* background-color: #eee; */
    height: 40px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 50px 0;
  }

  .btn {
    width: 130px;
    height: 100%;
    border: 1px solid #707070;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #2a2e43;
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 5px;
  }

  .btns {
    border: 1px solid #ff5000;
    color: #ff5000; 
  }
}
.top-tips {
  position: fixed;
  top: 46px;
  left: 0;
  width: 100%;
}
</style>


  